/**
 * 🐋 Login Component - Cetalingua FM Admin Panel
 * Used for Admin and Station operator login
 */

import React, { useState, useEffect } from 'react';
import PasswordInput from './common/PasswordInput';
import ForgotPassword from './common/ForgotPassword';
import { auth } from '../firebase-config';
import { signInWithEmailAndPassword } from 'firebase/auth';
import './Login.css';
import { preloadRecaptcha, getRecaptchaToken } from '../utils/recaptcha';
import portalIcon from '../assets/portal-icon.png';

export default function Login({ title = 'Admin Login' }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => { preloadRecaptcha(); }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await getRecaptchaToken('login'); // invisible security check (reCAPTCHA v3)
      await signInWithEmailAndPassword(auth, email, password);
      // Auth state change will be handled by App.js
    } catch (err) {
      console.error('Login error:', err);
      if (err.code === 'auth/invalid-credential') {
        setError('Invalid email or password');
      } else if (err.code === 'auth/too-many-requests') {
        setError('Too many failed attempts. Please try again later.');
      } else if (err.code === 'auth/user-not-found') {
        setError('No account found with this email');
      } else {
        setError(err.message || 'Login failed. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <img src={portalIcon} alt="Cetalingua portal" style={{ width: 80, height: 80, borderRadius: 18 }} />
          <h1>Cetalingua FM</h1>
          <h2>{title}</h2>
        </div>
        
        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              placeholder="admin@cetalingua.fm"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <PasswordInput
              id="password"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
            />
          </div>
          
          {error && <div className="error-message">{error}</div>}
          
          <button type="submit" disabled={loading} className="login-btn">
            {loading ? (
              <>
                <span className="btn-spinner"></span>
                Signing in...
              </>
            ) : (
              'Sign In'
            )}
          </button>
        </form>
        
        <ForgotPassword email={email} />
      </div>
    </div>
  );
}
